import { CustomerPortal } from 'types/site';

export const getInitialValues = (packages: CustomerPortal['packages']) => ({
  details: packages?.map((p) => ({
    sku: p._id,
    casesCount: '0',
  })),
  notes: '',
});
